<template>
    <div>
        <vx-card class="mb-4">
            <vs-popup title="Initialized Connection Tunnel" :active.sync="showInitTunnelForm">
                <!-- <vs-radio color="success" v-model="tunnelCommand" vs-value="CMDINITTUNNEL">Open Tunnel</vs-radio> &nbsp;
                <vs-radio color="danger" v-model="tunnelCommand" vs-value="CMDCLOSETUNNEL">Close Tunnel</vs-radio> -->
                <vs-input id="input-server-ip" v-model="tunnel_config.server_ip" placeholder="0.0.0.0" label="Server IP"/>
                <vs-input id="input-server-port" label="Server port" placeholder="22" type="number" v-model="tunnel_config.server_port"/>
                <vs-input id="input-reversessh-port" label="Port for reverse SSH" placeholder="20001" type="number" v-model="tunnel_config.reverse_ssh_port"/>
                <vs-input id="input-username" label="Username" placeholder="Username on target server" v-model="tunnel_config.username"/>
                <vs-input id="input-timeout" label="Connection Timeout (second)" placeholder="Connection Timeout (second)" type="number" min="0" v-model="tunnel_config.connection_timeout"/>
                <div class="w-full self-center" style="font-size: 11px">
                    Open tunnel connection will be automatically closed when the time out reached the setting <br>
                </div>
                <div id="btn-pop-container">
                    <vs-button class="btn-start-tunneling" id="btn-start-tunneling" @click="startTunneling()" :color="color3" :gradient-color-secondary="color4" type="gradient">Open Tunnel</vs-button>
                </div>
            </vs-popup>
            <vs-popup :title="restartOrShutdownTitle" :active.sync="showConfirmDialog">
                <p>Are you sure want to <strong>{{restartOrShutdownTitle}}</strong>?</p>
                <div id="btn-pop-container" style="float:right">
                    <vs-button class="mx-2" @click="startShutdownOrRestartDevice(commandName)" :color="color5" :gradient-color-secondary="color6" type="gradient">Yes</vs-button>
                    <vs-button color="dark" type="border" @click="closeRestartOrShutdownDialog()">Cancel</vs-button>
                </div>
    
            </vs-popup>
            <div class="w-full flex flex-no-wrap">
                <div class="w-3/4">
                    <h5 class="mb-4">Device Monitoring Detail</h5>
                    <div class="table-row w-full mb-4">
                        <div class="table-cell w-1/4 p-4">Device Name</div>
                        <div class="table-cell w-3/4 p-4">{{detail.device_name}}</div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/6 p-4">Device Code</div>
                        <div class="table-cell w-3/6 p-4">{{detail.device_code}}</div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Serial Number</div>
                        <div class="table-cell w-3/5 p-4">{{detail.serial_number}}</div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Status</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-chip v-bind:color="color(detail.device_is_online)">
                                 <vs-avatar  style="background: hsla(0, 0%, 100%, .2)"  v-bind:icon="icon(detail.device_is_online)" />
                                 {{((detail.device_is_online) ? 'Online':'Offline' )}}
                            </vs-chip>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Last Heartbeat </div>
                        <div class="table-cell w-3/5 p-4">{{((detail.timestamp !== null)? detail.timestamp.toString().replace("T", " "): "")}}</div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Last Login</div>
                        <div class="table-cell w-3/5 p-4">{{detail.last_login}}</div>
                    </div>
                    <!--<div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Last Sys Info Report</div>
                        <div class="table-cell w-3/5 p-4"> {{detail.last_sys_info_report}}</div>
                    </div>-->
                   <!-- <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Last Heartbeat</div>
                        <div class="table-cell w-3/5 p-4"> {{detail.last_heartbeat}}</div>
                    </div>-->
                  <!--  <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Tariffs Up To Date</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-chip v-bind:color="colorTrue(detail.tariff_is_uptodate)">
                                <vs-avatar  style="background: hsla(0, 0%, 100%, .2)"  v-bind:icon="iconTrue(detail.tariff_is_uptodate)" />
                                {{detail.tariff_is_uptodate}}
                            </vs-chip>
                        </div>
                    </div>-->
                   <!-- <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Discounts Up To Date</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-chip v-bind:color="colorTrue(detail.dicounts_uptodate)">
                                <vs-avatar  style="background: hsla(0, 0%, 100%, .2)"  v-bind:icon="iconTrue(detail.dicounts_uptodate)" />
                                {{detail.dicounts_uptodate}}
                            </vs-chip>
                        </div>
                    </div>-->
                   <!-- <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Payment Module Status</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-chip v-bind:color="colorTrue(detail.core_modules_status)">
                                <vs-avatar  style="background: hsla(0, 0%, 100%, .2)"  v-bind:icon="iconTrue(detail.core_modules_status)" />
                                {{detail.core_modules_status}}
                            </vs-chip>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Emoney Module Status</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-chip v-bind:color="colorTrue(detail.payment_modules_status)">
                                <vs-avatar  style="background: hsla(0, 0%, 100%, .2)"  v-bind:icon="iconTrue(detail.payment_modules_status)" />
                                {{detail.payment_modules_status}}
                            </vs-chip>
                        </div>
                    </div>-->
                 <!--   <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Receive Bytes</div>
                        <div class="table-cell w-3/5 p-4">{{readableBytes(detail.receive_bytes)}}</div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Send Bytes</div>
                        <div class="table-cell w-3/5 p-4">{{readableBytes(detail.send_bytes)}}</div>
                    </div>-->
                    <!--<div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Last Data Traffic Counter Reset</div>
                        <div class="table-cell w-3/5 p-4">{{detail.last_data_traffic_counter_reset}}</div>
                    </div>-->
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Software Version</div>
                        <div class="table-cell w-3/5 p-4" v-if='detail.software_version !== ""'>
                            <vs-button color="success" size="small" type="filled" v-bind:key="index" v-for="(data, index) in detail.software_version.split(';')" style="margin-bottom: 5px; margin-right:5px">
                                {{data}}
                            </vs-button>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">Core Modules Init Result</div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="table-row w-full mb-2" v-bind:key="index" v-for="(data, index) in detail.core_modules_init_result_f">
                                <div class="table-cell w-1/2 p-4">{{data.module_name}}</div>
                                <div class="table-cell w-1/2 p-4">
                                    <!-- <vs-button color="success" size="small" type="filled">
                                     {{data.module_status}}
                                    </vs-button> -->
                                    <vs-avatar v-if="data.module_status===true" color="success" size="small" icon="check"/>
                                    <vs-avatar v-else-if="data.module_status===false" color="danger" size="small" icon="close"/>
                                    <vs-avatar v-else size="small" text="N/A"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/6 p-4">Payment Modules Init Result</div>
                        <div class="table-cell w-4/6 p-4">
                            <vs-tabs v-model="selectedTab" >
                                    <div v-for="(d, i) in detail.channel_module_init_result" :key="i">
                                        <vs-tab :label="d.channel_name" >
                                            <vs-list>
                                                <vs-list-item  :key="idx" :title="idx.toString().replace('_', ' ')" v-for="(dt, idx) in detail.channel_module_init_result[i]" :subtitle="dt.toString()"></vs-list-item>
                                            </vs-list>
                                        </vs-tab>
                                    </div>
                                    <div v-show="show">
                                        <vs-tab  label="" >
                                            <div class="demo-alignment tab-text">

                                            </div>
                                        </vs-tab>
                                    </div>

                            </vs-tabs>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">
                          <div style="margin-top: -15px">
                          Device Capacity
                          </div>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div v-if="this.progress != null">
                              <div style="margin-top: -15px">
                                <h5 style="font-size: 15px;" :class="progress_color_text">{{ progress }} %</h5>
                                <vs-progress :percent="progress" :color="progress_color">primary</vs-progress>
                              </div>
                            </div>
                            <div v-else>
                              <div style="margin-top: -25px">
                                <vs-avatar text="N/A"/>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">
                          <div style="margin-top: -15px">
                          Ram Usage
                          </div>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div v-if="this.ram.progress != null">
                              <div style="margin-top: -15px">
                                <h5 style="font-size: 15px;" :class="ram.progress_color_text">{{ ram.progress }} % &nbsp;&nbsp;&nbsp;&nbsp;{{ ram.used }} / {{ ram.total }}</h5>
                                <vs-progress :percent="ram.progress" :color="ram.progress_color">primary</vs-progress>
                              </div>
                            </div>
                            <div v-else>
                              <div style="margin-top: -25px">
                                <vs-avatar text="N/A"/>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">
                          <div style="margin-top: -15px">
                          CPU Usage
                          </div>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div v-if="this.cpu.progress != null">
                              <div style="margin-top: -15px">
                                <h5 style="font-size: 15px;" :class="cpu.progress_color_text">{{ cpu.progress }} %</h5>
                                <vs-progress :percent="cpu.progress" :color="cpu.progress_color">primary</vs-progress>
                              </div>
                            </div>
                            <div v-else>
                              <div style="margin-top: -25px">
                                <vs-avatar text="N/A"/>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">
                          <div style="margin-top: -15px">
                          CPU One Minute
                          </div>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                          {{cpu.one_minute}}
                        </div>
                    </div>
                    <div class="mt-4 mb-6">
                        <vs-button :color="color1" :gradient-color-secondary="color2" type="gradient" id="btn-start-tunnel" class="ml-4" @click="openTunnelingForm()">Device Connection Tunnel</vs-button>
                        <vs-button :color="color7" :gradient-color-secondary="color8" type="gradient" class="ml-4" @click="openRestartOrShutdownDialog('CMDRESTART')">Restart Device</vs-button>
                        <vs-button :color="color5" :gradient-color-secondary="color6" type="gradient" class="ml-4" @click="openRestartOrShutdownDialog('CMDSHUTDOWN')">Shutdown Device</vs-button>
                    </div>
                    <!--<div class="table-row w-full mb-6">
                        <div class="table-cell w-2/5 p-4">System Info</div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="table-row w-full mb-2" v-bind:key="index" v-for="(data, index) in detail.system_info">
                                <div class="table-cell w-1/2 p-4">{{data.info_name.replace("_", " ")}}</div>
                                <div class="table-cell w-1/2 p-4" v-if="data.info_name === 'free_storage'">
                                    <vs-button :color="storage(readableBytes(data))"  size="small" type="filled">
                                        {{readableBytes(data.info_value)}}
                                    </vs-button>
                                </div>
                                <div class="table-cell w-1/2 p-4" v-else-if="data.info_name === 'cpu_load'">
                                    <pure-vue-chart
                                            :points="data.info_value.toString().split(',')"
                                            :width="40"
                                            :height="20"
                                    />
                                </div>
                                <div class="table-cell w-1/2 p-4" v-else-if="data.info_name === 'batterylevel'">
                                    <vs-progress :height="8" :percent="data" :color="getBatteryColor(data.info_value)"></vs-progress>
                                </div>
                                <div class="table-cell w-1/2 p-4" v-else >
                                    {{data.info_value}}
                                </div>
                            </div>
                        </div>
                    </div>-->

                </div>
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/4 mx-auto self-center">
                    <img src="@/assets/images/pages/graphic-4.png" alt="login" class="mx-auto" />
                </div>
            </div>
        </vx-card>

        <vx-card>
            <div class="w-full text-right">
                <vs-button id="btn-back" class="ml-4" @click="backTo">Back</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import AxiosCall from "@/global/AxiosCall";
    import { url } from "@/configs/apiUrl";
    import Axios from "@/global/AxiosCall";
    import moment from 'moment'
    import PureVueChart from 'pure-vue-chart';

    const CMDINITTUNNEL = "CMDINITTUNNEL"
    // const CMDCLOSETUNNEL = "CMDCLOSETUNNEL"

    export default {
        name: 'DeviceMonitoringDetail',
        components: {
            PureVueChart,
        },
        data() {
            return {
                color1:'#1a7a91',
                color2:'#0fc1d1',
                color3:'#910f73',
                color4:'#520852',
                color5:'#c0392b',
                color6:'#e74c3c',
                color7:'#f39c12',
                color8:'#f1c40f',
                showConfirmDialog: false,
                restartOrShutdownTitle: '',
                commandName: '',
                showInitTunnelForm:false,
                tunnelCommand:'',
                tunnel_config:{
                    server_ip : "",
                    server_port : 22,
                    reverse_ssh_port : 20001,
                    username : "",
                    connection_timeout : (60*60)
                },
                mqtt_message:{
                    version: "1.0.0",
                    command: "",
                    publish_at: "",
                    data: {}
                },
                selectedTab:3,
                show:false,
                detail: {
                    device_name:"",
                    device_code:"",
                    serial_number:"",
                    status:"",
                    device_is_online:false,
                    last_login : "",
                    timestamp:"",
                    last_sys_info_report : "",
                    last_heartbeat:  "",
                    tariff_is_uptodate:false,
                    dicounts_is_uptodate:false,
                    core_modules_status:false,
                    emoney_modules_status:false,
                    software_version:"",
                    receive_bytes:0,
                    send_bytes:0,
                    last_data_traffic_counter_reset:"",
                    core_modules_init_result:[],
                    core_modules_init_result_f: [],
                    channel_module_init_result:[],
                    system_info:{},
                },
                progress: null,
                progress_color: 'success',
                progress_color_text: 'text-success',
                progress_info: '',
                ram: {
                    progress: null,
                    progress_color: 'success',
                    progress_color_text: 'text-success',
                    progress_info: '',
                    used: null,
                    total: null,
                },
                cpu: {
                    progress: null,
                    progress_color: 'success',
                    progress_color_text: 'text-success',
                    progress_info: '',
                    one_minute: '',
                },
            }
        },
        computed: {
        },
        created: function() {

        },
        methods:{
            danger(title, text){
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: "danger",
                    position: "top-right"
                });
            },
            success(title, text){
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: "success",
                    position: "top-right"
                });
            },
            validateform(){
                return (!this.errors.any() &&
                    this.tunnel_config.server_ip !== "" &&
                    this.tunnel_config.server_port !== "" &&
                    this.tunnel_config.reverse_ssh_port !== "" &&
                    this.tunnel_config.username !== "" &&
                    this.tunnel_config.connection_timeout !== "" &&
                    this.tunnel_config.connection_timeout !== "0"
                )
            },
            closeTunnelingForm(){
                this.showInitTunnelForm  = false
            },
            openTunnelingForm(){
                if(this.detail.device_is_online == true) {
                    this.showInitTunnelForm  = true
                } else {
                    this.danger("Device offline", "Device status is offline");
                }
            },
            startTunneling(){
                if (!this.validateform()){
                    if (this.tunnel_config.server_ip === ""){
                        this.danger("Server IP", "Please fill server ip");
                    }
                    if (this.tunnel_config.server_port === ""){
                        this.danger("Server port", "Please fill server port");
                    }
                    if (this.tunnel_config.reverse_ssh_port === ""){
                        this.danger("Port for reverse SSH", "Please fill port for reverse SSH");
                    }
                    if (this.tunnel_config.username === ""){
                        this.danger("Username", "Please fill username");
                    }
                    if (this.tunnel_config.connection_timeout === ""){
                        this.danger("Connection timeout", "Please fill connection timeout");
                    }
                    if (this.tunnel_config.connection_timeout === "0"){
                        this.danger("Connection timeout", "Connection timeout cannot be zero");
                    }
                }else {
                    this.openLoading()
                    this.tunnel_config.server_port = (typeof this.tunnel_config.server_port == 'number') ? this.tunnel_config.server_port : parseInt(this.tunnel_config.server_port)
                    this.tunnel_config.reverse_ssh_port = (typeof this.tunnel_config.reverse_ssh_port == 'number') ? this.tunnel_config.reverse_ssh_port : parseInt(this.tunnel_config.reverse_ssh_port)
                    this.tunnel_config.connection_timeout = (typeof this.tunnel_config.connection_timeout == 'number') ? this.tunnel_config.connection_timeout : parseInt(this.tunnel_config.connection_timeout)
    
                    this.mqtt_message.publish_at = (+ new Date())
                    this.mqtt_message.command = CMDINITTUNNEL
                    this.mqtt_message.data = this.tunnel_config
    
                    let commandPayload = btoa(JSON.stringify(this.mqtt_message))
    
                    Axios.Post(url.device_remote.publish, {topic:"/topic/device/"+this.detail.device_code, payload:commandPayload})
                        .then(resp => {
                            this.$vs.loading.close();
                            this.dataTrx = [];
                            if (resp.status_code != 200) {
                                this.danger("Sent command failed", "Sent command failed");
                            } else {
                                this.success("Success", "Init tunnel instruction published, please wait for a moments while device initializing connection tunnel.")
                            }
                            this.closeTunnelingForm()
                        })
                        .catch(e => {
                            this.$vs.loading.close();
                            console.log(e);
                            this.closeTunnelingForm()
                        });
    
                    let user = JSON.parse(localStorage.getItem('userInfo'))
                    let payload = {
                        version:'1.0.0',
                        log_data:{
                            user_email: user.email,
                            activity: this.mqtt_message.command,
                            device_code: this.detail.device_code,
                            device_name: this.detail.device_name,
                            date_time: moment().format("YYYY-MM-DDTHH:mm:ss+07:00")
                        }
                    }
                    AxiosCall.Post(url.audit_trail.save_device_remote_activity, payload).then(resp => {
                         this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Device Monitoring",
                            activity: "Tunneling Device",
                            data_before: {},
                            data_after: payload,
                        })
                        console.log(resp)
                    }).catch(e => {
                        console.log(e)
                    })
                }
            },
            closeRestartOrShutdownDialog(){
                this.showConfirmDialog = false
            },
            openRestartOrShutdownDialog(commandName){
                if(this.detail.device_is_online == true) {
                    this.commandName = commandName
                    this.restartOrShutdownTitle = (commandName == 'CMDSHUTDOWN') ? 'Shutdown Device': 'Restart Device'
                    this.showConfirmDialog = true
                } else {
                    this.danger("Device offline", "Device status is offline");
                }
                
            },
            startShutdownOrRestartDevice(commandName) {
                this.openLoading()

                this.mqtt_message.publish_at = (+ new Date())
                this.mqtt_message.command = commandName
                this.mqtt_message.data = {}

                let commandPayload = btoa(JSON.stringify(this.mqtt_message))

                Axios.Post(url.device_remote.publish, {topic:"/topic/device/"+this.detail.device_code, payload:commandPayload})
                    .then((resp) => {
                         this.$vs.loading.close();
                         this.$vs.loading.close();
                        this.dataTrx = [];
                        if (resp.status_code != 200) {
                            this.danger("Sent command failed", "Sent command failed");
                        } else {
                            let restartSuccessMsg = "Restart device success"
                            let shutdownSuccessMsg = "Shutdown device success"
                            let successMsg = (commandName == 'CMDSHUTDOWN') ? shutdownSuccessMsg : restartSuccessMsg
                            this.success("Success", successMsg)
                        }
                         this.closeRestartOrShutdownDialog()
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                        console.log("error", e);
                        this.closeRestartOrShutdownDialog()
                    });

                let user = JSON.parse(localStorage.getItem('userInfo'))
                let payload = {
                    version:'1.0.0',
                    log_data:{
                        user_email: user.email,
                        activity: this.mqtt_message.command,
                        device_code: this.detail.device_code,
                        device_name: this.detail.device_name,
                        date_time: moment().format("YYYY-MM-DDTHH:mm:ss+07:00")
                    }
                }
                AxiosCall.Post(url.audit_trail.save_device_remote_activity, payload).then(resp => {
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Device Monitoring",
                        activity: (this.mqtt_message.command == 'CMDSHUTDOWN') ? "Shutdown device" : "Restart device",
                        data_before: {},
                        data_after: payload,
                    })
                    console.log(resp)
                }).catch(e => {
                    this.$vs.loading.close();
                    console.log(e)
                })
            },
            storage(value){
                let mem = value.split(" ")
                if (mem[0] < 100){
                    return "danger"
                }else if (mem[0] > 300){
                    return "success"
                }  else{
                    return "warning"
                }
            },
            getBatteryColor(data){
                if (data > 60){
                    return "success"
                }else if(data < 30){
                    return "danger"
                }else{
                    return "warning"
                }
            },
            color(status){
              if (status){
                  return "success"
              }else{
                  return "danger"
              }
            },
            icon(status){
              if (status){
                  return "verified_user"
              }else{
                  return "close"
              }
            },
            colorTrue(param){
                if (param){
                    return "success"
                }else{
                    return "danger"
                }
            },
            iconTrue(param){
                if (param){
                    return "verified_user"
                }else{
                    return "close"
                }
            },
            backTo(){
                this.$router.push({name:"DeviceMonitoring"})
            },
            warning(text, title){
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: "warning",
                    position: "top-right"
                });
            },
            openLoading(){
                this.$vs.loading({
                    type: 'default',
                })
            },
            readableBytes(bytes) {
                if (bytes > 0){
                    let i = Math.floor(Math.log(bytes) / Math.log(1024)),
                        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                    return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
                }else{
                    return "Unknown"
                }

            }
        },
        beforeMount(){

        },
        mounted() {
            if(this.$route.query.id !== undefined){
                this.openLoading()
                AxiosCall.Get(url.device_monitoring.detail+"/"+this.$route.query.id).then(resp =>{
                    this.$vs.loading.close()
                    this.detail = resp.data
    
                    if(resp.data.software_version !== undefined){
                        this.detail.software_version = resp.data.software_version
                    }else{
                        this.detail.software_version = ""
                    }

                    let core_modules_init_result_f = []
                    if (resp.data.hasOwnProperty('core_modules_init_result')) {
                      if (typeof resp.data.core_modules_init_result==="object") {
                        for(let data of resp.data.core_modules_init_result) {
                          if (data.hasOwnProperty('module_name') && data.hasOwnProperty('module_status')) {
                            let core_modules_init_result_detail = {}
                            core_modules_init_result_detail.module_name = data.module_name
                            core_modules_init_result_detail.module_status = data.module_status
                            core_modules_init_result_f.push(core_modules_init_result_detail)
                          }
                        }
                      }
                    }
                    this.detail.core_modules_init_result_f = core_modules_init_result_f

                    if (resp.data.hasOwnProperty('system_info')) {
                      if (resp.data.system_info.hasOwnProperty('used_disk') && resp.data.system_info.hasOwnProperty('total_disk')) {
                        if (resp.data.system_info.used_disk!=="N/A" && resp.data.system_info.total_disk!=="N/A") {
                          let used_disk = parseFloat(resp.data.system_info.used_disk)
                          let total_disk = parseFloat(resp.data.system_info.total_disk)
                          let result = (used_disk/total_disk) * 100
                          this.progress = parseFloat(result.toFixed(2))
                          if (this.progress > 85) {
                            this.progress_color = 'danger'
                            this.progress_color_text = 'text-danger'
                          } else if (this.progress>=70 && this.progress <= 85 ) {
                            this.progress_color = 'warning'
                            this.progress_color_text = 'text-warning'
                          } else {
                            this.progress_color = 'success'
                            this.progress_color_text = 'text-success'
                          }
                        } else {
                          this.progress = null
                        }
                      } else {
                        this.progress = null
                      }
                      if (resp.data.system_info.hasOwnProperty('total_ram') && resp.data.system_info.hasOwnProperty('total_ram')) {
                        if (resp.data.system_info.total_ram!=="N/A" && resp.data.system_info.free_ram!=="N/A") {
                          let free_ram = parseFloat(resp.data.system_info.free_ram)
                          let total_ram = parseFloat(resp.data.system_info.total_ram)
                          let used_ram = total_ram - free_ram
                          let result = (used_ram/total_ram) * 100
                          this.ram.progress = parseFloat(result.toFixed(2))
                          this.ram.used = this.readableBytes(used_ram)
                          this.ram.total = this.readableBytes(total_ram)
                          if (this.ram.progress > 85) {
                            this.ram.progress_color = 'danger'
                            this.ram.progress_color_text = 'text-danger'
                          } else if (this.ram.progress>=70 && this.ram.progress <= 85 ) {
                            this.ram.progress_color = 'warning'
                            this.ram.progress_color_text = 'text-warning'
                          } else {
                            this.ram.progress_color = 'success'
                            this.ram.progress_color_text = 'text-success'
                          }
                        } else {
                          this.ram.progress = null
                        }
                      } else {
                        this.ram.progress = null
                      }
                      if (resp.data.system_info.hasOwnProperty('cpuload')) {
                        if (resp.data.system_info.cpuload!=="N/A") {
                          let cpu_load = parseFloat(resp.data.system_info.cpuload)
                          this.cpu.progress = parseFloat(cpu_load.toFixed(2))
                          if (this.cpu.progress > 85) {
                            this.cpu.progress_color = 'danger'
                            this.cpu.progress_color_text = 'text-danger'
                          } else if (this.cpu.progress>=70 && this.cpu.progress <= 85 ) {
                            this.cpu.progress_color = 'warning'
                            this.cpu.progress_color_text = 'text-warning'
                          } else {
                            this.cpu.progress_color = 'success'
                            this.cpu.progress_color_text = 'text-success'
                          }
                        } else {
                          this.cpu.progress = null
                        }
                      } else {
                        this.cpu.progress = null
                      }
                      if (resp.data.system_info.hasOwnProperty('cpu_one_minute')) {
                        this.cpu.one_minute = resp.data.system_info.cpu_one_minute
                      } else {
                        this.cpu.one_minute = null
                      }
                    } else {
                      this.ram.progress = null
                      this.cpu.progress = null
                      this.progress = null
                    }
                   
                    // this.detail.softwareVersion = this.detail.softwareVersion.split(";")
                }).catch(e=>{
                    this.$vs.loading.close()
                    this.danger("Failed", "Failed get data."+e)
                })
            }

            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been rendered
               let changetab =  setInterval(()=>{
                    this.selectedTab = 1
                }, 100)

                setTimeout(()=>{
                    clearInterval(changetab)
                }, 200)
            })
        },
    }
</script>

<style>
    #btn-pop-container {margin-top: 15px;}
    .vs-con-input-label {width: 100%;}
    .con-vs-avatar.small {
        width: 24px;
        height: 24px;
        top: 10px;
    }
</style>